import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DynamicAdSlot } from './DynamicAdSlot.js';
import { FallbackAdSlot } from './FallbackAdSlot.js';
export const AdSlot = ({ kevelAd, imageDimensions, variation, imageSizes }) => {
    const adType = kevelAd.content.__typename;
    return (_jsxs(_Fragment, { children: [adType === 'DynamicAdContent' && _jsx(DynamicAdSlot, { content: kevelAd.content.body }), adType === 'FallbackAdContent' && (_jsx(FallbackAdSlot, { imageId: variation === 'mobile'
                    ? kevelAd.content.mobileImage.id
                    : kevelAd.content.desktopImage.id, imageSizes: imageSizes, imageDimensions: imageDimensions, altText: kevelAd.content.altText }))] }));
};
//# sourceMappingURL=AdSlot.js.map